module.exports = __webpack_public_path__ + "static/media/galerija_2023 (15).78e0648a.png";